export default function orgLinkFilter($state, utils) {
	"ngInject";

	return function (org) {
		return $state.href(utils.getOrgStateName(org), utils.getOrgStateParams(org));
	};
}
